import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    // Show the first tab by default if none are active
    if (!this.tabTargets.find(tab => tab.classList.contains('border-indigo-500'))) {
      this.activate(this.tabTargets[0])
    }
  }

  switch(event) {
    const clickedTab = event.currentTarget
    this.activate(clickedTab)
  }

  activate(tab) {
    if (!tab) return

    // Update tab styling + aria-selected for a11y
    this.tabTargets.forEach(t => {
      t.classList.remove('border-indigo-500', 'text-indigo-600')
      t.classList.add('border-transparent', 'text-gray-500')
      t.setAttribute('aria-selected', 'false')
    })
    tab.classList.remove('border-transparent', 'text-gray-500')
    tab.classList.add('border-indigo-500', 'text-indigo-600')
    tab.setAttribute('aria-selected', 'true')

    // Show corresponding panel by matching tab's data-tab-panel to panel id
    const panelId = tab.dataset.tabPanel
    this.panelTargets.forEach(panel => {
      if (panel.id === panelId) {
        panel.classList.remove('hidden')
      } else {
        panel.classList.add('hidden')
      }
    })
  }
}
